import * as Model from '@mms-v3/data-model-js';
import { WriteObligationValue } from '@mms-v3/data-model-js';
import { SessionState } from './interfaces';

export function checkReadPermission(field: Model.Field, roles: string[], isOwn: boolean): boolean {
  if (!field) {
    console.warn('field is null or undefined', field, roles);
    return false;
  }
  return field.readPermission(roles, isOwn);
}

export function checkWriteObligation(field: Model.Field, roles: string[], isOwn: boolean): 'OPTIONAL' | 'RECOMMENDED' | 'MANDATORY' | false {
  if (!field) {
    console.warn('field is null or undefined', field, roles);
    return false;
  }
  const obligation: WriteObligationValue | false = field ? field.writeObligation(roles, isOwn) : false;
  // Replace `NONE` with `false` for simple truthyness checks (e.g. `if (writable) ...`)
  return obligation === 'NONE' ? false : obligation;
}

export function checkIsOwnRecord(session: SessionState, isNew?: boolean, emails?: string[]): boolean {
  if (isNew) {
    return true;
  }
  if (!session) {
    return false;
  }
  const userEmail: string = session?.user_name?.toLowerCase();
  if (userEmail == null || userEmail.length === 0) {
    return false;
  }
  return emails.findIndex((e: string): boolean => e.toLowerCase() === userEmail) !== -1;
}
